import script from "./CourseTopics.vue?vue&type=script&setup=true&lang=js"
export * from "./CourseTopics.vue?vue&type=script&setup=true&lang=js"

import "./CourseTopics.vue?vue&type=style&index=0&id=526ce996&scoped=true&lang=scss"

import exportComponent from "/var/www/html/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-526ce996"]])

export default __exports__